"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _DBindNew = _interopRequireDefault(require("../DBindNew"));

var _DGoogle = _interopRequireDefault(require("../DGoogle"));

var _Button = _interopRequireDefault(require("../Button"));

var _message = require("@/components/dialog/message");

var _security = require("@/model/ucenter/security");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    DBind: _DBindNew.default,
    DGoogle: _DGoogle.default,
    GButton: _Button.default
  },
  props: ["accountInfo", "emailStatus", "mobileStatus", "googleStatus"],
  data: function data() {
    return {
      confirmLoading: false
    };
  },
  created: function created() {},
  methods: {
    onConfirm: function onConfirm() {
      var _this = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, emailCheck, mobileCheck, googleCheck, data, _data, _data2, result;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {};
                emailCheck = _this.$refs.email_ref ? _this.$refs.email_ref.submitForm() : true;
                mobileCheck = _this.$refs.mobile_ref ? _this.$refs.mobile_ref.submitForm() : true;
                googleCheck = _this.$refs.google_ref ? _this.$refs.google_ref.submitForm() : true;

                if (emailCheck && mobileCheck && googleCheck) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return");

              case 6:
                if (_this.$refs.email_ref) {
                  data = _this.$refs.email_ref.submitForm();
                  delete data.email;
                  params = (0, _objectSpread2.default)({}, data);
                }

                if (_this.$refs.mobile_ref) {
                  _data = _this.$refs.mobile_ref.submitForm();
                  delete _data.area;
                  delete _data.mobile;
                  params = Object.assign(params, (0, _objectSpread2.default)({}, _data));
                }

                if (_this.$refs.google_ref) {
                  _data2 = _this.$refs.google_ref.submitForm();
                  params = Object.assign(params, (0, _objectSpread2.default)({}, _data2));
                }

                if (!(_this.googleStatus == 1)) {
                  _context.next = 16;
                  break;
                }

                _context.next = 12;
                return (0, _security.closeGoogleVerify)(params);

              case 12:
                result = _context.sent;

                _this.subTips(result, "关闭谷歌认证成功");

                _context.next = 21;
                break;

              case 16:
                if (!(_this.googleStatus == 2)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 19;
                return (0, _security.openGoogleVerify)(params);

              case 19:
                result = _context.sent;

                _this.subTips(result, "开启谷歌认证成功");

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    subTips: function subTips(res, msg) {
      if (res.status == 200) {
        (0, _message.showMessage)({
          message: msg,
          type: "success"
        });
        this.$emit("subSuccess");
        this.$emit("onCancel");
      }
    }
  },
  computed: {
    emailType: function emailType() {
      return this.googleStatus == 2 ? "27" : "29";
    },
    mobileType: function mobileType() {
      return this.googleStatus == 2 ? "28" : "30";
    }
  }
};
exports.default = _default;